import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Truck } from "lucide-react";

const STATUS_LABEL = { disponivel: "Disponível", locada: "Locada", oficina: "Oficina", extraviada: "Extraviada" };

export default function PortalEquipamentos() {
  const [unidades, setUnidades] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    Promise.all([api.get("/unidades"), api.get("/modelos")])
      .then(([u, m]) => { setUnidades(u.data || []); setModelos(m.data || []); })
      .catch(() => { setUnidades([]); setModelos([]); })
      .finally(() => setLoaded(true));
  }, []);

  const mMap = Object.fromEntries(modelos.map((m) => [m.id, m]));
  const vazio = loaded && unidades.length === 0;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-3xl font-display font-bold" style={{ color: "#1B3A6B" }}>Meus equipamentos</h1>
        <p className="text-sm text-muted-foreground mt-1">
          {vazio ? "Nenhum equipamento vinculado" : `${unidades.length} equipamentos em sua posse`}
        </p>
      </div>

      {vazio ? (
        <Card className="p-10 text-center border-dashed" data-testid="portal-equip-empty">
          <Truck size={36} className="mx-auto text-slate-300" />
          <h3 className="mt-3 text-base font-semibold text-slate-700">
            Você ainda não possui equipamentos vinculados à sua frota.
          </h3>
          <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">
            Quando o time comercial finalizar a associação de equipamentos ao seu contrato,
            eles aparecerão aqui automaticamente.
          </p>
        </Card>
      ) : (
        <Card>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nº Série</TableHead>
                <TableHead>Modelo</TableHead>
                <TableHead>Fabricante</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {unidades.map((u) => (
                <TableRow key={u.id}>
                  <TableCell className="font-mono text-xs">{u.numero_serie}</TableCell>
                  <TableCell>{mMap[u.modelo_id]?.nome}</TableCell>
                  <TableCell>{mMap[u.modelo_id]?.fabricante}</TableCell>
                  <TableCell><span className={`status-dot status-${u.status}`} />{STATUS_LABEL[u.status]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
